import React from "react";
import { BsGithub } from "react-icons/bs";
import { FaLinkedinIn } from "react-icons/fa";
import { MdOutlineMail } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa"

const SocialMedia = () => {
  return (
    <div className="app__social">
      <div style={{ cursor: "pointer" }}>
        <a href="https://github.com/RAHUL14KUMAR/" target="_blank" rel="noreferrer">
          <BsGithub />
        </a>
      </div>
      <div style={{ cursor: "pointer" }}>
        <a
          href="https://www.linkedin.com/in/rahul-kumar-216872227/"
          target="_blank"
          rel="noreferrer"
        >
          <FaLinkedinIn />
        </a>
      </div>
      <div style={{ cursor: "pointer" }}>
        <a
          href="agrawal.r1412@gmail.com"
          target="_blank"
          rel="noreferrer"
        >
          <MdOutlineMail />
        </a>
      </div>
      <div style={{ cursor: "pointer" }}>
        <a
          a href="tel:+91 8240662720" 
          target="_blank"
          rel="noreferrer"
        >
          <FaPhoneAlt />
        </a>
      </div>
    </div>
  );
};

export default SocialMedia;
